module.exports = __webpack_public_path__ + "static/banner-categories-detail-edit-6e4ae3561890790013d0c68db7791114.png";